import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

// redux
import { connect } from 'react-redux';

import { Typography } from '@comparethemarketau/manor-typography';

import { destructNumber, currencySymbol, decimalPoint } from './number_formatter';
import { paymentFrequencyStateMapping, frequencyFilterTypes } from '../../filters/common/filter_store_mapping';

const useStyles = createUseStyles((theme) => ({
    priceDollars: {
        fontSize: '4.4rem',
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.grey900
    },
    priceCents: {
        fontSize: '3.8rem',
        fontWeight: theme.fontWeight.semibold,
        color: theme.colors.grey900
    }
}));

const _ProductPrice = ({ frequencyFilter, productMonthlyPremium, productAnnualPremium, priceDollarsClassName, priceCentsClassName }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });
    const price = frequencyFilter === 'monthly' ? productMonthlyPremium : productAnnualPremium;

    const amount = destructNumber(price);

    return (
        <Typography className={classNames(classes.priceDollars, priceDollarsClassName)} component="div">
            {currencySymbol}
            {amount.dollars}
            {decimalPoint}
            <Typography className={classNames(classes.priceCents, priceCentsClassName)} display="inline">
                {amount.cents}
            </Typography>
        </Typography>
    );
};

_ProductPrice.propTypes = {
    productAnnualPremium: PropTypes.number,
    productMonthlyPremium: PropTypes.number,
    /**
     * monthly or annual from redux
     */
    frequencyFilter: PropTypes.oneOf(frequencyFilterTypes),
    /**
     * Styles to be overwrited
     */
    priceDollarsClassName: PropTypes.string,
    priceCentsClassName: PropTypes.string
};

const ProductPrice = connect(paymentFrequencyStateMapping)(_ProductPrice);

export { ProductPrice };
